import { z } from 'zod'
import { RemoteImage, RemoteImageSchema } from './strapi/image'
import { PackageType } from './strapi/package'
import { BundleType } from './strapi/order'
import { refractionSchema } from '../schema'
import { StrapiID, StrapiIdSchema } from './strapi'

// We could mostly infer types but it might be better for ts perf to keep it as is

export const ItemRecommendationSchema = z.object({
  variable: z.string(),
  value: z.string(),
  bundles: z.array(z.nativeEnum(BundleType)).nullish(),
  deals: z.array(z.string()).nullish(),
})

export type ItemRecommendation = {
  variable: string
  value: string
  bundles?: BundleType[] | null
  deals?: string[] | null
}

// Avatar API Response Types
export const InitializeSessionResponseSchema = z.object({
  success: z.boolean(),
  sessionId: z.string().or(z.number()),
  ttl: z.string(),
})

export type InitializeSessionResponse = z.infer<
  typeof InitializeSessionResponseSchema
>

export const ExtendSessionResponseSchema = z.object({
  ttl: z.string(),
})

export type ExtendSessionResponse = z.infer<typeof ExtendSessionResponseSchema>

// Avatar API Request Types
export const InitializeSessionRequestSchema = z.object({
  storeId: z.string().or(z.number()),
  serialNumber: z.string().optional(),
  refraction: refractionSchema,
})

export type InitializeSessionRequest = z.infer<
  typeof InitializeSessionRequestSchema
>

// Reusable session input schema for operations that only need sessionId
export const SessionInputSchema = z.object({
  // sessionId: z.string().or(z.number()),
  storeId: z.string().or(z.number()),
  serialNumber: z.string().optional(),
})

export const SpeakRequestSchema = z.object({
  context: SessionInputSchema,
  text: z.string(),
  stop: z.boolean(),
})

export type SpeakRequest = z.infer<typeof SpeakRequestSchema>

export type SessionInput = z.infer<typeof SessionInputSchema>

// Generic success response for methods without specific response format
export const SuccessResponseSchema = z
  .object({
    success: z.boolean().optional(),
    message: z.string().optional(),
  })
  .passthrough()

export type SuccessResponse = z.infer<typeof SuccessResponseSchema>
